namespace Gamification.Gamification {
    export class ProdottiLivelliEditorColumns {
        static columnsKey = 'Gamification.ProdottiLivelliEditor';
    }
}
